<template>
  <div class="overview">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <date-range-input
            ref="dateRange"
            :value="selectedDates"
            :options="{ required: true }"
            @input="getStats($event)">
          </date-range-input>
        </div>
        <div class="row">
          <div class="col">
            <div class="btn-group-toggle mb-2" data-toggle="buttons">
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'day' }">
                <input @click="refreshStats('day')" type="radio" id="option1">
                  Today
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'week' }">
                <input @click="refreshStats('week')" type="radio" id="option2">
                  Past Week
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'month' }">
                <input @click="refreshStats('month')" type="radio" id="option3">
                  Past Month
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'threeMonths' }">
                <input @click="refreshStats('threeMonths')" type="radio" id="option4">
                  Past 3 Months
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'sixMonths' }">
                <input @click="refreshStats('sixMonths')" type="radio" id="option5">
                  Past 6 Months
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'year' }">
                <input @click="refreshStats('year')" type="radio" id="option6">
                  Past Year
              </label>
            </div>
            <div class="card">
              <div class="content">
                <chart
                  :currency="true"
                  :labels="incomeData.labels"
                  :datasets="incomeData.datasets"
                  ref="incomeData" :type="'bar'"
                  :scales="incomeChartScale">
                </chart>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="alert alert-info" role="alert">
              Total Invoiced: {{ totalInvoiced }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card">
              <div class="content">
                <chart
                  :labels="reportTypeData.labels"
                  :datasets="reportTypeData.datasets"
                  ref="reportTypeData" :type="'pie'">
                </chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .card a {
    color: #000;
    &:hover {
      text-decoration: none;
    }
  }
</style>

<script>
  import { LOAD_STATS } from '@/vuex/types'
  import { mapGetters } from 'vuex'
  import Chart from '@/components/displays/Chart'
  import DateRangeInput from '@/components/inputs/DateRangeInput'
  export default {
    name: 'Stats',
    components: {
      DateRangeInput,
      Chart
    },
    computed: {
      totalInvoiced () {
        if (this.stats.totalInvoiced) {
          return '$' + this.stats.totalInvoiced.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        } else {
          return '$0.00'
        }
      },
      ...mapGetters([
        'stats'
      ]),
      incomeData () {
        return {
          ...this.stats.incomeData
        }
      },
      reportTypeData () {
        return {
          ...this.stats.reportTypeData
        }
      }
    },
    data () {
      return {
        myChart: '',
        period: 'month',
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        },
        timer: '',
        timePassed: 0,
        loadedTime: moment(),
        incomeChartScale: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            stacked: true
          }]
        },
        selectedDates: {
          startDate: moment().subtract(1, 'month'),
          endDate: moment()
        }
      }
    },
    async mounted () {
      await this.$store.dispatch(LOAD_STATS)
      await this.$nextTick()
      if (this.$refs.reportTypeData && this.$refs.incomeData) {
        this.$refs.reportTypeData.refresh()
        this.$refs.incomeData.refresh()
        this.autoReloadTimer = setInterval(this.getNow, 60000)
      }
    },
    beforeDestroy () {
      clearInterval(this.autoReloadTimer)
    },
    methods: {
      getNow () {
        this.timePassed = moment().diff(this.loadedTime, 'minutes')
      },
      async getStats (eventData) {
        this.selectedDates.startDate = eventData.startDate
        this.selectedDates.endDate = eventData.endDate
        let payload = {}
        payload.selectedDates = this.selectedDates
        await this.$store.dispatch(LOAD_STATS, payload)
        await this.$nextTick()
        if (this.$refs.reportTypeData && this.$refs.incomeData) {
          this.$refs.reportTypeData.refresh()
          this.$refs.incomeData.refresh()
          this.autoReloadTimer = setInterval(this.getNow, 60000)
        }
      },
      refreshStats (period) {
        let payload = {}
        this.period = period
        switch (period) {
          case 'day':
            payload.startDate = moment()
            break
          case 'week':
            payload.startDate = moment().subtract(6, 'days')
            break
          case 'month':
            payload.startDate = moment().subtract(1, 'month')
            break
          case 'threeMonths':
            payload.startDate = moment().subtract(3, 'months')
            break
          case 'sixMonths':
            payload.startDate = moment().subtract(6, 'months')
            break
          case 'year':
            payload.startDate = moment().subtract(1, 'year')
            break
        }
        payload.endDate = moment()
        this.$refs.dateRange.setDateRange(payload)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/Stats.vue